import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	IReportsContainerContext,
	ReportsContainerContext,
	CREATE_REPORT,
} from '../../../../reportsContainerState/reportsContainerContext';
import { IReportsContext, ReportsContext } from '../../reportsContext/reportsState/reportsContext';
import {
	IEditRestaurantContext,
	EditRestaurantContext,
} from '../../../../../../../../editRestaurantState/editRestaurantContext';
import { TTypeOfReport } from 'types';
import { TIPS_JAR_CLIENT_TYPE } from 'appConstants';
import { Form } from 'antd';
import ReportTypeSelect from './components/ReportTypeSelect';
import ScheduleTypesMultipleSelect from './components/ScheduleTypesMultipleSelect';
import SendingReportAfterShiftClosingCheckbox from './components/SendingReportAfterShiftClosingCheckbox';
import EmailsBlock from './components/EmailsBlock';
import CopyEmailsBlock from './components/CopyEmailsBlock';
import BtnBlock from './components/BtnBlock';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const { deleteReport } = useContext<IReportsContainerContext>(ReportsContainerContext);
	const { clientType } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const {
		setIDReportType,
		setIDsScheduleTypes,
		addEmails,
		changeEmails,
		deleteEmails,
		addCopyEmails,
		changeCopyEmails,
		deleteCopyEmails,
		toggleSendingReportAfterShiftClosing,
		setDataForSubmit,
		changeTypeOfModalWindow,
		hasBanOnChanges,
		restaurantId,
		id,
		IDReportType,
		IDsScheduleTypes,
		emails,
		copyEmails,
		sendingReportAfterShiftClosing,
	} = useContext<IReportsContext>(ReportsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDReportType,
			IDsScheduleTypes,
		});
		emails.forEach((el) => form.setFieldsValue({ [el.id]: el.email }));
		copyEmails.forEach((el) => form.setFieldsValue({ [el.id]: el.email }));
		form.setFieldsValue({ sendingReportAfterShiftClosing });
	}, [IDReportType, IDsScheduleTypes, emails, copyEmails, sendingReportAfterShiftClosing]);

	useEffect(() => {
		if (id === CREATE_REPORT && clientType === TIPS_JAR_CLIENT_TYPE && IDReportType !== 'Detailed') {
			setIDReportType('Detailed');
		}
	}, [id, clientType, IDReportType]);

	const submit = () => {
		setDataForSubmit({
			restaurantId,
			id: id,
			reportType: IDReportType as TTypeOfReport,
			scheduleTypes: IDsScheduleTypes,
			emails: emails.map((el) => el.email),
			copyEmails: copyEmails.filter((el) => el.email).map((el) => el.email),
			isShiftsWorking: sendingReportAfterShiftClosing,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleDeleteReport = () => {
		deleteReport(id);
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="infoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<ReportTypeSelect
							setIDReportType={setIDReportType}
							isDisabled={id !== CREATE_REPORT || clientType === TIPS_JAR_CLIENT_TYPE}
						/>
						<ScheduleTypesMultipleSelect
							setIDsScheduleTypes={setIDsScheduleTypes}
							IDReportType={IDReportType}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="emailsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<div>
							<Text
								translationNameSpace="form"
								translationKey="mainRecipientHeading"
								theme="secondary"
								size="s"
								weight="bold"
								display="inline"
							/>
							<EmailsBlock
								addEmails={addEmails}
								changeEmails={changeEmails}
								deleteEmails={deleteEmails}
								emails={emails}
							/>
						</div>
						<div>
							<Text
								translationNameSpace="form"
								translationKey="copyHeading"
								theme="secondary"
								size="s"
								weight="bold"
								display="inline"
							/>
							<Text
								className={style.inputDescription}
								translationNameSpace="form"
								translationKey="optionalLabel"
								theme="secondary"
								size="s"
								weight="bold"
								display="inline"
							/>
							<CopyEmailsBlock
								addCopyEmails={addCopyEmails}
								changeCopyEmails={changeCopyEmails}
								deleteCopyEmails={deleteCopyEmails}
								copyEmails={copyEmails}
							/>
						</div>
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sendingReportHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<SendingReportAfterShiftClosingCheckbox
						toggleSendingReportAfterShiftClosing={toggleSendingReportAfterShiftClosing}
						sendingReportAfterShiftClosing={sendingReportAfterShiftClosing}
						disabled={IDReportType === 'Fees'}
					/>
				</div>
				<BtnBlock
					onDeleteReport={handleDeleteReport}
					changeTypeOfModalWindow={changeTypeOfModalWindow}
					disableDeleteBtn={id === CREATE_REPORT}
					hasBanOnChanges={hasBanOnChanges}
				/>
			</Form>
		</div>
	);
};
